module.exports = {
    // 开发环境
    development: {
        NODE_ENV: "development",
        base_url: "http://192.168.101.42:80" //测试服务器地址
    },
    // 测试环境
    test: {
        NODE_ENV: 'test',
        base_url: 'http://192.168.101.42:80', // 测试服务器地址
    },
    // 生产环境
    production: {
        NODE_ENV: "production",
        base_url: "https://aries.kaduocai.com:443", // 正式服务器地址
        // base_url: 'http://192.168.101.42:80', // 测试服务器地址
    }
}